/**
 * Цитаты клиентов кода возражения (#846): по одной с разговора, переход в
 * разговор с подсветкой цитаты, отработано или нет. Весь список кода — или
 * разговоры выбранной корзины ряда (`ObjectionCodeCard`).
 */
import { useTranslation } from 'react-i18next';
import type { ObjectionStreamCode } from '@aica/api-types/schemas';
import { cn } from '@/lib/utils';

interface ObjectionQuotesProps {
  quotes: readonly ObjectionStreamCode['quotes'][number][];
  onOpenCall: (recordId: string, quote: string) => void;
}

export function ObjectionQuotes({ quotes, onOpenCall }: ObjectionQuotesProps) {
  const { t } = useTranslation('dashboard');
  return (
    <ul className="space-y-1">
      {quotes.map((quote) => (
        <li key={quote.recordId}>
          <button
            type="button"
            className="w-full border-l-2 border-border pl-2 text-left text-xs italic text-fg-subtle transition-colors hover:border-primary hover:text-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            onClick={() => onOpenCall(quote.recordId, quote.quote)}
          >
            &ldquo;{quote.quote}&rdquo;
            <span
              className={cn(
                'ml-2 not-italic',
                quote.handled ? 'text-success' : 'text-danger'
              )}
            >
              {quote.handled
                ? t('objectionsPage.handled')
                : t('objectionsPage.unhandled')}
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
}
